import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Alert, Table, Dropdown, Form, Spinner, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LanguageProvider } from '../../../core/language-provider';
import { AuthorizationManager } from '../../../core/authorization-manager';
import { ViewManager } from '../../../core/view-manager';
import { DataManager } from '../../../core/data-manager';
import ModalDetails from '../../../components/Modals/ModalDetails';
import ModalDelete from '../../../components/Modals/ModalDelete';
import FieldPreviewSimple from '../../../components/Entity/FieldPreviewSimple';
import DataGridOptions from '../../../components/Entity/DataGridOptions';
import DataGridSelection from '../../../components/Entity/DataGridSelection';
import ColumnFilter from './ColumnFilter';
import { Utils } from '../../../core/utils';
import DataGridActionHook from '../../../components/Hooks/DataGridAction';
import DataGridTrHook from '../../../config/hooks/DataGridTrHook';
import DataGridLastTdHook from '../../../config/hooks/DataGridLastTdHook';
import DataGridTopHook from '../../../config/hooks/DataGridTopHook';
import _ from "lodash";


export default function DataGrid({ data, setData, props, entity, params, changeSorting, searchObj, setSearchObj, refreshData, loading, total }) {

    const navigate = useNavigate();
    const [userPreferences, setUserPreferences] = useState(null);
    const [userAllPreferences, setUserAllPreferences] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        getUserPreferences()
    }, [entity]);

    async function getUserPreferences() {
        var c = [
            {
                fieldName: 'entity',
                type: 'value',
                value: entity
            }
        ]
        var response = await DataManager.searchItems('user_entity_preferences', 1, 50, { 'field': 'id', 'order': 'ASC' }, '', [], c)
        if (response.success === 1) {
            if (response.body && response.body.length) {
                var defaultObj = response.body.find(obj => obj.isDefault === 1);
                if (defaultObj) {
                    var item = defaultObj
                }
                else {
                    var item = response.body[0]
                }
                var n = JSON.parse(item.content)
                setUserPreferences(n)
                setUserAllPreferences(response.body)
                // Applica ordinamento dalla preferenza se presente
                if (n.sorting && n.sorting.field) {
                    changeSorting(n.sorting.field, n.sorting.order || 'desc');
                }
            }
            else {
                let c = Utils.cloneObject(ViewManager.getVisibleColumns(entity))
                var defaultPreferences = {
                    'columns': c
                }
                setUserPreferences(defaultPreferences)
                setUserAllPreferences(null)
            }
        }
    }

    async function updatePreferences() {
        await getUserPreferences()
    }


    //modals content
    const [modalDetailsData, setModalDetailsData] = useState(null)
    const [modalDeleteData, setModalDeleteData] = useState(null)

    /* panels */
    function edit(i) {
        if (props.reference_entity) {
            navigate('/entity/' + props.reference_entity + '/edit?id=' + data[i].id)
        }
        else {
            navigate('/entity/' + entity + '/edit?id=' + data[i].id)
        }
    }


    /* modals */
    /* open */
    function open(i) {
        let item = data[i]
        setModalDetailsData(item)
    }
    function closeModalDetails() {
        setModalDetailsData(null)
    }
    /* remove */
    function remove(i) {
        let item = data[i]
        setModalDeleteData(item)
    }
    function closeModalDelete() {
        setModalDeleteData(null)
    }
    async function confirmModalDelete(item) {
        var temp = [...data]
        const index = temp.indexOf(item);
        if (index > -1) {
            temp.splice(index, 1);
        }
        setData(temp)
        setModalDeleteData(null)
    }
    function doubleClicked(i) {
        open(i)
    }

    function clone(i) {
        if (props.reference_entity) {
            navigate('/entity/' + props.reference_entity + '/clone?id=' + data[i].id)
        }
        else {
            navigate('/entity/' + entity + '/clone?id=' + data[i].id)
        }
    }

    function openInNewPage(i) {
        if (props.reference_entity) {
            navigate('/entity/' + props.reference_entity + '/item?id=' + data[i].id)
        }
        else {
            navigate('/entity/' + entity + '/item?id=' + data[i].id)
        }
    }






    function handleCheckboxChange(event, item) {
        const target = event.target
        const checked = target.checked

        var t = [...selectedRows]
        if (checked === true) {
            t.push(item.id)
        }
        else {
            t = Utils.removeFromArray(t, item.id)
        }
        setSelectedRows(t)
        console.log(t)
    }

    function search(obj) {
        if (_.isEqual(obj, searchObj)) {
            console.log('searchObj = : non triggero la ricerca')
            // oggetti uguali non triggero la ricerca
        }
        else {
            console.log('searchObj <> : triggero la ricerca')
            setSearchObj(obj)
        }
    }


    if (data && userPreferences !== null && entity) {
        return (
            <>

                {/* hook */}
                <DataGridTopHook entity={entity} params={params} data={data} setData={setData} searchObj={searchObj} setSearchObj={search} total={total} refreshData={refreshData} />

                <Card>
                    <Card.Body style={{ padding: 0 }}>
                        {data ? (
                            <>
                                <Row className='m-2'>
                                    <Col xs={12} md={4}>
                                        <DataGridSelection data={data} setData={setData} props={props} entity={entity} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData} />
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <div className='small text-muted text-center'>
                                            {loading === true ? (
                                                <span>
                                                    {LanguageProvider.get('defaults.loading')} <Spinner className='ms-1' size='sm' animation="border" variant="secondary" />
                                                </span>
                                            ) : (
                                                <span>&nbsp;</span>
                                            )}
                                        </div>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <DataGridOptions data={data} props={props} entity={entity} entityPreferences={userPreferences} entityAllPreferences={userAllPreferences} updatePreferences={updatePreferences} params={params} searchObj={searchObj} refreshData={refreshData} />
                                    </Col>
                                </Row>

                                <div className='data-grid-container'>
                                    <Table striped hover responsive className="datagrid-table small" data-entity-name={entity}>
                                        <thead className='small'>
                                            <tr>
                                                <th className='multi-select'></th>
                                                {userPreferences.columns.map((item, i) => {
                                                    if (props.columns[item]) {
                                                        return (
                                                            <th key={i} data-column-name={item}>
                                                                <ColumnFilter
                                                                    fieldName={item}
                                                                    fieldConfig={props.columns[item]}
                                                                    entity={entity}
                                                                    params={params}
                                                                    changeSorting={changeSorting}
                                                                    searchObj={searchObj}
                                                                    setSearchObj={search}
                                                                />
                                                            </th>
                                                        )
                                                    }
                                                })}
                                                <th className='head-last-td' colSpan={2}>{LanguageProvider.get('defaults.actions')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item, i) => {
                                                return (
                                                    <React.Fragment key={i}>
                                                        <tr onDoubleClick={() => doubleClicked(i)} data-entity={entity} data-id={item.id ? item.id : 'none'}>
                                                            <td className='multi-select'>
                                                                <Form.Check // prettier-ignore
                                                                    type={'checkbox'}
                                                                    label={''}
                                                                    checked={selectedRows.includes(item.id)}
                                                                    onChange={(e) => handleCheckboxChange(e, item)}
                                                                />
                                                            </td>
                                                            {userPreferences.columns.map((key, j) => {
                                                                if (props.columns[key]) {
                                                                    return (
                                                                        <td key={j}>
                                                                            <FieldPreviewSimple item={item} field={key} props={props} entity={entity} />
                                                                        </td>
                                                                    )
                                                                }
                                                            })}
                                                            <td className='text-end last-td' colSpan={2}>
                                                                <table className='ms-auto'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <DataGridLastTdHook item={item} props={props} entity={entity} data={data} setData={setData} refreshData={refreshData} />
                                                                            </td>
                                                                            <td>
                                                                                <Dropdown className='position-static'>
                                                                                    <Dropdown.Toggle variant="outline-secondary" data-bs-boundary="viewport" size="sm">
                                                                                        <FontAwesomeIcon icon="cog" />
                                                                                    </Dropdown.Toggle>

                                                                                    <Dropdown.Menu>
                                                                                        <Dropdown.Item className='small datagrid-dropdown-view' onClick={() => openInNewPage(i)}>{LanguageProvider.get('defaults.view')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="eye" /></span></Dropdown.Item>
                                                                                        {
                                                                                            {
                                                                                                'true': <Dropdown.Item className='small datagrid-dropdown-edit' onClick={() => edit(i)}>{LanguageProvider.get('defaults.edit')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="edit" /></span></Dropdown.Item>,
                                                                                                'false': <></>,
                                                                                                'group':
                                                                                                    <>
                                                                                                        {props.authorization && item[props.authorization.groupField] && (
                                                                                                            <>
                                                                                                                {props.columns[props.authorization.groupField].input_type === 'number' ? (
                                                                                                                    <>
                                                                                                                        {item[props.authorization.groupField] == JSON.parse(localStorage.getItem('userInfo')).idUserGroup && (
                                                                                                                            <Dropdown.Item className='small datagrid-dropdown-edit' onClick={() => edit(i)}>{LanguageProvider.get('defaults.edit')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="edit" /></span></Dropdown.Item>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        {item[props.authorization.groupField].id == JSON.parse(localStorage.getItem('userInfo')).idUserGroup && (
                                                                                                                            <Dropdown.Item className='small datagrid-dropdown-edit' onClick={() => edit(i)}>{LanguageProvider.get('defaults.edit')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="edit" /></span></Dropdown.Item>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>,
                                                                                                'user':
                                                                                                    <>
                                                                                                        {props.authorization && item[props.authorization.userField] && (
                                                                                                            <>
                                                                                                                {props.columns[props.authorization.userField].input_type === 'number' ? (
                                                                                                                    <>
                                                                                                                        {item[props.authorization.userField] == JSON.parse(localStorage.getItem('userInfo')).id && (
                                                                                                                            <Dropdown.Item className='small datagrid-dropdown-edit' onClick={() => edit(i)}>{LanguageProvider.get('defaults.edit')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="edit" /></span></Dropdown.Item>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        {item[props.authorization.userField].id == JSON.parse(localStorage.getItem('userInfo')).id && (
                                                                                                                            <Dropdown.Item className='small datagrid-dropdown-edit' onClick={() => edit(i)}>{LanguageProvider.get('defaults.edit')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="edit" /></span></Dropdown.Item>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>
                                                                                            }[AuthorizationManager.checkEntityActionAuth(entity, 'edit')]
                                                                                        }

                                                                                        {AuthorizationManager.checkEntityActionAuth(entity, 'create') !== false ? (
                                                                                            <Dropdown.Item className='small datagrid-dropdown-clone' onClick={() => clone(i)}> {LanguageProvider.get('defaults.clone')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="clone" /></span></Dropdown.Item>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}

                                                                                        {
                                                                                            {
                                                                                                'true': <Dropdown.Item className='small datagrid-dropdown-delete' onClick={() => remove(i)}>{LanguageProvider.get('defaults.delete')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="trash" /></span></Dropdown.Item>,
                                                                                                'false': <></>,
                                                                                                'group':
                                                                                                    <>
                                                                                                        {props.authorization && item[props.authorization.groupField] && (
                                                                                                            <>
                                                                                                                {props.columns[props.authorization.groupField].input_type === 'number' ? (
                                                                                                                    <>
                                                                                                                        {item[props.authorization.groupField] == JSON.parse(localStorage.getItem('userInfo')).idUserGroup && (
                                                                                                                            <Dropdown.Item className='small datagrid-dropdown-delete' onClick={() => remove(i)}>{LanguageProvider.get('defaults.delete')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="trash" /></span></Dropdown.Item>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        {item[props.authorization.groupField].id == JSON.parse(localStorage.getItem('userInfo')).idUserGroup && (
                                                                                                                            <Dropdown.Item className='small datagrid-dropdown-delete' onClick={() => remove(i)}>{LanguageProvider.get('defaults.delete')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="trash" /></span></Dropdown.Item>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>,
                                                                                                'user':
                                                                                                    <>
                                                                                                        {props.authorization && item[props.authorization.userField] && (
                                                                                                            <>
                                                                                                                {props.columns[props.authorization.userField].input_type === 'number' ? (
                                                                                                                    <>
                                                                                                                        {item[props.authorization.userField] == JSON.parse(localStorage.getItem('userInfo')).id && (
                                                                                                                            <Dropdown.Item className='small datagrid-dropdown-delete' onClick={() => remove(i)}>{LanguageProvider.get('defaults.delete')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="trash" /></span></Dropdown.Item>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        {item[props.authorization.userField].id == JSON.parse(localStorage.getItem('userInfo')).id && (
                                                                                                                            <Dropdown.Item className='small datagrid-dropdown-delete' onClick={() => remove(i)}>{LanguageProvider.get('defaults.delete')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="trash" /></span></Dropdown.Item>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>
                                                                                            }[AuthorizationManager.checkEntityActionAuth(entity, 'delete')]
                                                                                        }

                                                                                        <DataGridActionHook entity={entity} data={item} refreshData={refreshData} />

                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <DataGridTrHook item={item} props={props} entity={entity} refreshData={refreshData} />
                                                    </React.Fragment>
                                                )
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td className='text-end' colSpan={userPreferences.columns.length + 3}>
                                                    <span className='text-muted small'>{LanguageProvider.get('defaults.rows')} {data.length} {total && total > 0 ? ( <>/ {total} </>) : null }</span>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </Table>
                                </div>
                            </>
                        ) : (
                            <>
                                <Alert variant="warning">
                                    {LanguageProvider.get('defaults.no_results')}
                                </Alert>
                            </>
                        )}
                    </Card.Body>
                </Card>

                <ModalDetails entity={entity} props={props} data={modalDetailsData} closeModalDetails={closeModalDetails} entityAllPreferences={userAllPreferences} />
                <ModalDelete entity={entity} props={props} data={modalDeleteData} closeModalDelete={closeModalDelete} confirmModalDelete={confirmModalDelete} />
            </>
        );
    }
};